module.exports = __webpack_public_path__ + "img/51.31dd73c0.jpg";